import React, { SVGProps } from 'react'

const SvgCheck = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'var(--color-highlight)'}
      strokeWidth={props.strokeWidth || '1.25'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.3334 4.5L6.00008 11.8333L2.66675 8.5"
    />
  </svg>
)
export default SvgCheck
